import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

import { MentionElement, MentionNavigationKey } from '@recruitee/prosemirror';
import { KeyboardEventCode } from '@recruitee/user-interface';

@Component({
  selector: 'rt-mentions',
  templateUrl: './mentions.component.html',
  styleUrls: ['./mentions.component.less'],
  host: {
    '(keyup)': 'onKeyUp($event)',
  },
})
export class MentionsComponent implements OnInit, OnDestroy {
  public highlightedIndex = 0;
  public searchFormControl = new FormControl('');

  public searchEnabled: boolean;
  public queryChange: (val: string) => void;
  public select: (val: MentionElement) => void;
  public data: MentionElement[];

  private ngOnDestroy$ = new Subject();

  constructor(private cdRef: ChangeDetectorRef) {}

  public ngOnInit() {
    this.searchFormControl.valueChanges
      .pipe(startWith(this.searchFormControl.value), takeUntil(this.ngOnDestroy$))
      .subscribe(value => this.queryChange(value));
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public onKeyUp(event: KeyboardEvent) {
    this.handleKey(<MentionNavigationKey>event.key);
  }

  public onElementHover(index: number) {
    this.highlightedIndex = index;
    this.cdRef.detectChanges();
  }

  public handleKey(key: MentionNavigationKey): void {
    if (KeyboardEventCode.Enter === key) {
      this.select(this.data[this.highlightedIndex]);
    } else if (KeyboardEventCode.ArrowDown === key) {
      this.highlightedIndex = (this.highlightedIndex + 1) % this.data.length;
      this.cdRef.detectChanges();
    } else if (KeyboardEventCode.ArrowUp === key) {
      this.highlightedIndex =
        this.highlightedIndex === 0
          ? this.data.length - 1
          : (this.highlightedIndex - 1) % this.data.length;
      this.cdRef.detectChanges();
    }
  }

  public trackByMention(index: number, item: MentionElement) {
    return `${item.type}${item.id}`;
  }
}
